import { render, staticRenderFns } from "./ColorModuleSearch.vue?vue&type=template&id=eb700aa6&scoped=true"
import script from "./ColorModuleSearch.vue?vue&type=script&lang=ts"
export * from "./ColorModuleSearch.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleSearch.vue?vue&type=style&index=0&id=eb700aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb700aa6",
  null
  
)

export default component.exports